@if (isAppReady()) {
  <router-outlet />
}
<z-loader />
<z-toaster />
